<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<a id="page08">
</a><a id="page09">
<h2 class="contentsHead" style="text-indent: 0%;">Contents</h2>
</a><div class="contentsEntry"><a id="page09">
</a><p class="contentsEntryName"><a id="page09"></a><a href="#/9780765316578_pt01#pt01">Huda</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/9780765316578_pt02#pt02" title="Link target outside of Sample">Afkar</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/9780765316578_pt03#pt03" title="Link target outside of Sample">Karima</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/9780765316578_pt04#pt04" title="Link target outside of Sample">Selwa</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/9780765316578_pt05#pt05" title="Link target outside of Sample">Yusriyya</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/9780765316578_pt06#pt06" title="Link target outside of Sample">Samira</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/9780765316578_bm01#bm01" title="Link target outside of Sample">Author’s Note</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/9780765316578_bm02#bm02" title="Link target outside of Sample">Glossary</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/9780765316578_bm03#bm03" title="Link target outside of Sample">Discussion Questions</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780765316578_con01.vue?b6a56c4a